import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../../app/shared/models/campo-aggiuntivo";

function Stagioni() {
  var OBJ: OggettoConfig = {
    Id: "stagioni",
    MenuItems:[],
    RestRoute:"/prodotti/stagioni",
    ListResponseHasData:true,
    HasAddList:{},
    PrintHeaders:[],
    campi:[
      CampoAggiuntivo.TextField("Nome", 'check', )
    ],
    Headers:[
      CampoAggiuntivo.TextField("Nome", 'check', "col-12",{modificabile:false})
    ]
  }
  return OBJ;
}


export var StagioniEnv = () => {
  var env: any = {
    Modules: {
      "Stagioni": true
    },
    Cruds: [Stagioni()],
    Menu: [...Stagioni().MenuItems]
  }
  return env;

}
